module.exports = __webpack_public_path__ + "img/Groupe 88.06b17a85.svg";